export default {
  needHelp: 'Need help?',
};
